import { Component, inject } from '@angular/core';
import { BodyanalyticsBaseComponent } from '@bodyanalytics/ui-core';
import { RegisterService } from '../../services/register.service';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'bodyanalytics-registration',
  imports: [RouterOutlet],
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent extends BodyanalyticsBaseComponent {
  private router = inject(Router);
  private registerService = inject(RegisterService);

  public readonly pageHeader = 'sms';
}
